module.exports = __webpack_public_path__ + "img/UK.7d8e25fe.jpg";